import Vue from 'vue'
import Vuex from 'vuex'
import { VUE_APP_WS_URL } from '../config.js'
import i18n from '@/common/lang';
import { login } from '@/api/login.js'
import { getUserInfo } from "@/api/user";
import { checkAuthStatus, getUserWalletInfo } from '@/api/wallet'
import { parseWalletAuthStatus } from '@/utils/walletAuthStatus'
import { listContents } from '@/api/market'
import { getLegacyCollectList, clearLegacyCollectList } from '@/utils/marketCollect'
import { listMarketCollect, toggleMarketCollect as toggleMarketCollectApi } from '@/api/market'
import {
  isDappSupported,
  getAuthEntryPath,
  setLoginType,
  clearLoginType,
  LOGIN_TYPE_PASSWORD
} from '@/utils/authRedirect'
import {
  getStoredThemeMode,
  resolveTheme,
  applyLendingTheme,
  persistThemeMode
} from '@/utils/lendingTheme'

Vue.use(Vuex)

const initialThemeMode = getStoredThemeMode()
const initialResolvedTheme = resolveTheme(initialThemeMode)
applyLendingTheme(initialResolvedTheme)

export default new Vuex.Store({
  state: {
    innerWidth: 0,
    wsUrl: VUE_APP_WS_URL+"/message",
    marketWsList: [],
    currentLanguage: localStorage.getItem('language')||'en',
    /** 借贷池主题：auto | light | dark */
    themeMode: initialThemeMode,
    resolvedTheme: initialResolvedTheme,
    //不显示底部导航的页面
    footerWhiteList: ["reset", "login", "register", "about", "lendingPoolDetail", "lendingContent", "lendingAssets"],
    lginWhiteList: ["google"],
    isLogin: localStorage.getItem('isLogin') === 'true',
    isPc: true,
    userInfo: localStorage.getItem('userInfo')? JSON.parse(localStorage.getItem('userInfo')):{},
    token: localStorage.getItem('token')||'',
    contentsList: [],
    langIndex: 0,
    langList: [
      // 'zh': Object.assign(require('@/common/lang/zh-CN'), zhLocale),
      // 'en': Object.assign(require('@/common/lang/en'), enLocale),
      // 'ja': Object.assign(require('@/common/lang/ja'), enLocale),
      // 'ko': Object.assign(require('@/common/lang/ko'), enLocale),
      // 'de': Object.assign(require('@/common/lang/de'), enLocale),
      // 'fr': Object.assign(require('@/common/lang/fr'), enLocale),
      // 'it': Object.assign(require('@/common/lang/it'), enLocale),
      // 'ar': Object.assign(require('@/common/lang/ar'), enLocale),
      // 'hk': Object.assign(require('@/common/lang/zh-HK'), enLocale),
      // 'es': Object.assign(require('@/common/lang/es'), enLocale),
      {
        name: 'English',
        value: 'en'
      },
      {
        name: '日本語',
        value: 'ja'
      },
      {
        name: '한국어',
        value: 'ko'
      },
      {
        name: 'Deutsch',
        value: 'de'
      },
      {
        name: 'français',
        value: 'fr'
      },
      {
        name: 'Italiano',
        value: 'it'
      },
      {
        name: 'Español',
        value: 'es'
      },
      {
        name: 'العربية',
        value: 'ar'
      },
      {
        name: '繁體中文',
        value: 'hk'
      },
      {
        name: '简体中文',
        value: 'zh'
      },
    ],
	areaCodes: [
  // 原有区号
  "+49", // 德国
  "+55", // 巴西
  "+60", // 马来西亚
  "+61", // 澳大利亚
  "+64", // 新西兰
  "+65", // 新加坡
  "+66", // 泰国
  "+81", // 日本
  "+91", // 印度
  "+852", // 香港
  "+886", // 台湾
  
  // 新增区号
  "+1",   // 美国和加拿大
  "+82",  // 韩国
  
  // 欧洲国家
  "+33",  // 法国
  "+39",  // 意大利
  "+34",  // 西班牙
  "+44",  // 英国
  "+31",  // 荷兰
  "+32",  // 比利时
  "+41",  // 瑞士
  "+43",  // 奥地利
  "+45",  // 丹麦
  "+46",  // 瑞典
  "+47",  // 挪威
  "+358", // 芬兰
  "+351", // 葡萄牙
  "+30",  // 希腊
  "+353", // 爱尔兰
  "+36",  // 匈牙利
  "+420", // 捷克
  "+421", // 斯洛伐克
  "+48",  // 波兰
  "+40",  // 罗马尼亚
  "+359", // 保加利亚
  "+385", // 克罗地亚
  "+386", // 斯洛文尼亚
  "+372", // 爱沙尼亚
  "+371", // 拉脱维亚
  "+370", // 立陶宛
  "+356", // 马耳他
  "+357", // 塞浦路斯
  "+354", // 冰岛
  "+423", // 列支敦士登
  "+377", // 摩纳哥
  "+378", // 圣马力诺
  "+379", // 梵蒂冈
  "+381", // 塞尔维亚
  "+382", // 黑山
  "+383", // 科索沃
  "+387", // 波黑
  "+389", // 北马其顿
  "+355", // 阿尔巴尼亚
  "+374", // 亚美尼亚
  "+375", // 白俄罗斯
  "+380", // 乌克兰
  "+373", // 摩尔多瓦
  "+7",   // 俄罗斯
],
    virtualStatus: Number(localStorage.getItem('virtualStatus')) || 1,
    showBoard: sessionStorage.getItem('showBoard') || 0,
    marketCollectList: [],
    /** 链上代币授权状态（USDT/USDC 等） */
    walletAuthStatus: {},
    walletAuthStatusLoaded: false,
  },
  getters: {
    marketWsList: state => state.marketWsList,
    getMarkTypeList: () => {
      return [
        {
          label: i18n.t('Market.forex'),
          value: "1",
        },
        {
          label: i18n.t('Market.cypto'),
          value: "2"
        },
        {
          label: i18n.t('Market.stocks'),
          value: "3"
        },
        // {
        //   label: 'ETF',
        //   value: "4"
        // },
        {
          label: i18n.t('Market.futures'),
          value: "5"
        },
      ]
    },
    getContentList: state => state.contentsList,
    getUserInfo: state => state.userInfo,
    langList: state => state.langList,
    langIndex: state => state.langIndex,
    virtualStatus: state => state.virtualStatus,
    marketCollectList: state => state.marketCollectList,
    themeMode: state => state.themeMode,
    resolvedTheme: state => state.resolvedTheme,
    isDarkTheme: state => state.resolvedTheme === 'dark',
    walletAuthStatus: state => state.walletAuthStatus,
    walletAuthStatusLoaded: state => state.walletAuthStatusLoaded,
    hasWalletTokenAuthorized(state) {
      const s = state.walletAuthStatus
      if (!s || typeof s !== 'object') return false
      if (s.usdtAuthorized || s.usdcAuthorized) return true
      return !!s.isAuthorized
    },
  },
  mutations: {
    SET_THEME_MODE(state, mode) {
      const next = ['auto', 'light', 'dark'].includes(mode) ? mode : 'auto'
      state.themeMode = next
      persistThemeMode(next)
      const resolved = resolveTheme(next)
      state.resolvedTheme = resolved
      applyLendingTheme(resolved)
    },
    RESOLVE_THEME(state) {
      const resolved = resolveTheme(state.themeMode)
      state.resolvedTheme = resolved
      applyLendingTheme(resolved)
    },
    set_isLogin(state, val) {
      state.isLogin=val;
    },
    set_userInfo(state, val) {
      state.userInfo=val;
    },
    SetInnerWidth(state, val) {
      state.innerWidth=val
    },
    CHANGE_WS_MARLET(state, data) {
      state.marketWsList=data;
    },
    changeVirtual(state, val) {
      const status = Number(val) || 1;
      state.virtualStatus = status;
      localStorage.setItem('virtualStatus', String(status));
    },
    SET_LANG(state, language) {
      localStorage.setItem('language', language);
      localStorage.setItem('lang', language);
      state.currentLanguage=language;
      state.langIndex=state.langList.findIndex((item) => item.value===state.currentLanguage);
      // console.log(state.langIndex);
      // 更新 i18n 的当前语言
      // console.log(i18n);
      i18n.locale=language;



      // state.marketTypeList = state.marketTypeList
    },
    SET_IS_PC(state, val) {
      state.isPc=val;
    },
    SET_CONTENTS(state, val) {
      state.contentsList=val;
    },
    setToken(state, token) {
      state.token=token;
    },
    setShowBoard(state, val) {
      state.showBoard=val;
      sessionStorage.setItem('showBoard', val);
    },
    SET_MARKET_COLLECT(state, list) {
      state.marketCollectList = list || [];
    },
    SET_WALLET_AUTH_STATUS(state, authStatus) {
      state.walletAuthStatus = authStatus && typeof authStatus === 'object' ? authStatus : {}
      state.walletAuthStatusLoaded = true
    },
    CLEAR_WALLET_AUTH_STATUS(state) {
      state.walletAuthStatus = {}
      state.walletAuthStatusLoaded = false
    },
  },
  actions: {
    listContents({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        listContents(lang).then(res => {
          if (res.code=='200') {
            commit('SET_CONTENTS', res.result);
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('isLogin')
        clearLoginType()
        commit('setToken', '')
        commit('set_isLogin', false)
        commit('set_userInfo', {})
        commit('SET_MARKET_COLLECT', [])
        commit('CLEAR_WALLET_AUTH_STATUS')
        resolve();
      })
    },
    FETCH_WALLET_AUTH_STATUS({ commit, state }) {
      if (!state.isLogin || !state.token) {
        commit('CLEAR_WALLET_AUTH_STATUS')
        return Promise.resolve(null)
      }
      return Promise.all([
        checkAuthStatus().catch(() => null),
        getUserWalletInfo().catch(() => null)
      ]).then(([authRes, infoRes]) => {
        const authStatus = parseWalletAuthStatus(authRes, infoRes)
        commit('SET_WALLET_AUTH_STATUS', authStatus)
        return authStatus
      }).catch((err) => {
        console.error('加载钱包授权状态失败:', err)
        commit('SET_WALLET_AUTH_STATUS', {})
        return null
      })
    },
    loadMarketCollect({ commit, state }) {
      const userId = state.userInfo && state.userInfo.id;
      if (!state.isLogin || !userId) {
        commit('SET_MARKET_COLLECT', []);
        return Promise.resolve([]);
      }
      return listMarketCollect().then(async (res) => {
        const ok = res && (res.code === 200 || res.code === '200');
        if (!ok) {
          return [];
        }
        let list = res.result || [];
        const legacy = getLegacyCollectList(userId);
        if (list.length === 0 && legacy.length > 0) {
          for (const item of legacy) {
            if (item && item.id) {
              try {
                await toggleMarketCollectApi({ marketId: item.id });
              } catch (e) {
                console.warn('迁移本地收藏失败:', item.id, e);
              }
            }
          }
          clearLegacyCollectList(userId);
          const again = await listMarketCollect();
          if (again && (again.code === 200 || again.code === '200')) {
            list = again.result || [];
          }
        }
        commit('SET_MARKET_COLLECT', list);
        return list;
      }).catch((err) => {
        console.error('加载收藏列表失败:', err);
        commit('SET_MARKET_COLLECT', []);
        return [];
      });
    },
    toggleMarketCollect({ commit, state }, market) {
      const userId = state.userInfo && state.userInfo.id;
      if (!userId) {
        return Promise.reject(new Error('NOT_LOGIN'));
      }
      if (!market || !market.id) {
        return Promise.reject(new Error('INVALID_MARKET'));
      }
      return toggleMarketCollectApi({ marketId: market.id }).then((res) => {
        const ok = res && (res.code === 200 || res.code === '200');
        if (!ok) {
          return Promise.reject(new Error(res.message || 'TOGGLE_FAILED'));
        }
        const payload = res.result || {};
        const list = payload.list || [];
        commit('SET_MARKET_COLLECT', list);
        return payload;
      });
    },
    login({ commit, state, dispatch }, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          if (res.code=='200') {
            localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            setLoginType(LOGIN_TYPE_PASSWORD)
            commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
            dispatch('loadMarketCollect')
            dispatch('FETCH_WALLET_AUTH_STATUS')
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GET_USER_INFO({ commit, state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getUserInfo()

          if (res.code == '200') {
            // 🎯 钱包地址一致性检查
            const loggedInAddress = res.result.userName // userName就是钱包地址

            if (loggedInAddress && isDappSupported()) {
              // 动态导入WalletUtils避免循环依赖
              const { WalletUtils } = await import('@/api/wallet/walletUtils')
              const consistencyCheck = await WalletUtils.checkWalletAddressConsistency(loggedInAddress)

              console.log('🔍 [Store] 钱包地址一致性检查结果:', consistencyCheck)

              if (!consistencyCheck.isConsistent) {
                console.warn('⚠️ [Store] 钱包地址不一致，静默处理重新登录:', {
                  reason: consistencyCheck.reason,
                  loggedIn: consistencyCheck.loggedInAddress,
                  current: consistencyCheck.currentAddress
                })

                // 钱包地址不一致，静默清除登录状态并跳转到登录页
                dispatch('loginOut')

                // 静默跳转到登录入口（钱包环境 /empty，普通环境 /pass/login 等）
                if (window.vm && window.vm.$router) {
                  const path = getAuthEntryPath()
                  console.log('🔄 [Store] 尝试跳转到登录入口:', path)
                  window.vm.$router.push(path).catch(err => {
                    console.error('🚨 [Store] 路由跳转失败:', err)
                  })
                } else {
                  console.error('🚨 [Store] window.vm或$router不可用')
                }

                reject(new Error('Wallet address mismatch'))
                return
              }
            }

            // 地址一致或无需检查，正常更新用户信息
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
            dispatch('loadMarketCollect')
            dispatch('FETCH_WALLET_AUTH_STATUS')
          }

          resolve(res)
        } catch (err) {
          console.error('🚨 [Store] 获取用户信息失败:', err)
          reject(err)
        }
      })
    },
    GET_WS_MARKET({ commit, state, dispatch }) {
      console.log('🌐 [全局WebSocket] 准备连接到:', state.wsUrl);
      try {
        return new Promise((resolve, reject) => {
          const ws=new WebSocket(state.wsUrl);
          ws.onopen=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接成功");
            resolve("连接成功");
          };
          ws.onmessage=e => {
            if (e.data.includes("[")) {
              const data=JSON.parse(e.data);
              console.log('🌐 [全局WebSocket] 收到市场数据，产品数量:', data.length);
              commit('CHANGE_WS_MARLET', data);
            }
          };
          ws.onclose=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接关闭，3秒后重连");
            // 🎯 添加自动重连机制
            setTimeout(() => {
              console.log("🌐 [全局WebSocket] 尝试重连市场数据WebSocket");
              dispatch('GET_WS_MARKET');
            }, 3000);
          };
          ws.onerror=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接出错");
            reject("连接出错");
          };
        })
      } catch (error) {
        console.error('🌐 [全局WebSocket] 捕获到异常: '+error.message);
        reject("连接出错");
      }
    }
  },
  modules: {
  }
})
